import React, { Fragment, useEffect, useRef, useState } from "react";
import { StyledCaretLeft, StyledCaretRight, StyledFlexItem, StyledFlexWrapper, StyledXOfY } from "./styled";
import { useImageInputContext } from "../../../../ImageInputContext";
import { calcAspectRatio } from "../../../ImageEditor/utils/calcAspectRatio";

import { colors, SANS_3, icons } from "oolib";

const { greyColor80 } = colors;

const { CaretLeft, CaretRight } = icons;

export const SliderShell = ({
  value,
  activeIdx,
  setActiveIdx,
  render,
}) => {

  const {aspectRatio, isLoading, imageUnderEdit} = useImageInputContext()
  const [isHeightSet, setIsHeightSet] = useState(false);

  const wrapperRef = useRef(null);
  const [imageMinusCaptionHeight, setImageMinusCaptionHeight] = useState(undefined);
  const updateHeight = () => {
    if (wrapperRef.current) {
      setImageMinusCaptionHeight(
        wrapperRef.current.clientWidth / calcAspectRatio(aspectRatio)
      );
      setIsHeightSet(true);
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);

    const intervalId = setInterval(() => {
      // to avoid issues in cases where height is initally 0 because parent block has display:hidden condition on initial render
      if (!isHeightSet) {
        updateHeight();
      } else {
        clearInterval(intervalId);
      }
    }, 100);

    return () => {
      window.removeEventListener('resize', updateHeight);
      intervalId && clearInterval(intervalId);
    };
  }, []);


  return (
    <StyledFlexWrapper ref={wrapperRef}>
      {value.map((v, idx) => (
        <StyledFlexItem
        key={v?.publicUrl || idx}
        marginLeft={idx === 0 && activeIdx * -100 + "%"}
        >
          {
            render(
              v,
              idx
            ) /* explicitly called, cuz we want an error to throw if render prop aint passed thru */
          }
        </StyledFlexItem>
      ))}
      {!isLoading && value.length > 1 && !imageUnderEdit && <Fragment>
        <StyledCaretLeft
        onClick={() =>
          setActiveIdx(activeIdx > 0 ? activeIdx - 1 : value.length - 1)
        }
        imageMinusCaptionHeight={imageMinusCaptionHeight}
      >
        <CaretLeft
          weight="duotone"
          size={45}
          color={greyColor80}
        />
      </StyledCaretLeft>
        <StyledCaretRight 
        imageMinusCaptionHeight={imageMinusCaptionHeight}
        onClick={() =>
          setActiveIdx(activeIdx < value.length - 1 ? activeIdx + 1 : 0)
        }>
        <CaretRight
        weight="duotone"
        size={45}
        color={greyColor80}
        
       
      />
        </StyledCaretRight>
        <StyledXOfY imageMinusCaptionHeight={imageMinusCaptionHeight}>
      <SANS_3>
        {activeIdx + 1 + "/" + value.length}
      </SANS_3>
      </StyledXOfY>
      </Fragment>}
      
      
      
    </StyledFlexWrapper>
  );
};
